/**
 * モーダルなどを開いている時に背景を固定する
 * @see https://zenn.dev/tak_dcxi/articles/bbdb6cd9305ba4
 */

// スクロールバーの幅を計算する
const getScrollBarSize = () => {
  return window.innerWidth - document.body.clientWidth;
};

// スクロール位置を取得する
const getScrollPosition = (fixed) => {
  if (fixed) {
    return document.scrollingElement ? document.scrollingElement.scrollTop : 0;
  }
  return parseInt(document.body.style.top || '0', 10);
};

// 背面固定のスタイルを適用する
const applyStyles = (scrollPosition, apply) => {
  const styles = {
    height: '100dvh',
    left: '0',
    position: 'fixed',
    top: `${scrollPosition * -1}px`,
    width: '100dvw',
  };
  Object.entries(styles).forEach(([key, value]) => {
    document.body.style[key] = apply ? value : '';
  });
};

// スクロール位置を元に戻す
const restorePosition = (scrollPosition) => {
  window.scrollTo({
    behavior: 'instant',
    top: scrollPosition * -1,
  });
};

// 背面を固定する
export const backfaceFixed = (fixed) => {
  const scrollBarWidth = getScrollBarSize();
  const scrollPosition = getScrollPosition(fixed);
  document.body.style.paddingRight = fixed ? `${scrollBarWidth}px` : '';
  applyStyles(scrollPosition, fixed);
  if (!fixed) {
    restorePosition(scrollPosition);
  }
};